import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGuidesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Guides_Bool_Exp>;
}>;


export type GetGuidesQuery = { __typename?: 'query_root', guides: Array<{ __typename?: 'guides', id: any, updated_at: any, title?: string | null, status: string, description?: string | null, video_url?: string | null, thumbnail_url?: string | null, thumbnail_timestamp_ms?: any | null, created_by_user_id?: string | null, organization_id?: any | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, title: string, body?: string | null, image_url?: string | null, video_url?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, photo_link?: string | null, installed_products: Array<{ __typename?: 'installed_products', id: any, property_id: any, photo_link?: string | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null }> } | null }> }>, product_categories: Array<{ __typename?: 'product_categories', name: string, label: string }> };


export const GetGuidesDocument = gql`
    query getGuides($where: guides_bool_exp) {
  guides(where: $where) {
    id
    updated_at
    title
    status
    description
    video_url
    thumbnail_url
    thumbnail_timestamp_ms
    guide_steps {
      id
      title
      body
      image_url
      video_url
    }
    product_guides {
      id
      product {
        id
        photo_link
        installed_products(distinct_on: property_id) {
          id
          property_id
          photo_link
        }
        product_attachments {
          id
          photo_link
        }
      }
    }
    created_by_user_id
    organization_id
  }
  product_categories {
    name
    label
  }
}
    `;

/**
 * __useGetGuidesQuery__
 *
 * To run a query within a React component, call `useGetGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuidesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetGuidesQuery(baseOptions?: Apollo.QueryHookOptions<GetGuidesQuery, GetGuidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuidesQuery, GetGuidesQueryVariables>(GetGuidesDocument, options);
      }
export function useGetGuidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuidesQuery, GetGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuidesQuery, GetGuidesQueryVariables>(GetGuidesDocument, options);
        }
export function useGetGuidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuidesQuery, GetGuidesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuidesQuery, GetGuidesQueryVariables>(GetGuidesDocument, options);
        }
export type GetGuidesQueryHookResult = ReturnType<typeof useGetGuidesQuery>;
export type GetGuidesLazyQueryHookResult = ReturnType<typeof useGetGuidesLazyQuery>;
export type GetGuidesSuspenseQueryHookResult = ReturnType<typeof useGetGuidesSuspenseQuery>;
export type GetGuidesQueryResult = Apollo.QueryResult<GetGuidesQuery, GetGuidesQueryVariables>;